export const FADE_TRANSITION_TIME = 500; // 0.5 sec
export const SLIDE_TRANSITION_TIME = 5000; // 5 sec

export const SPACE_3XL = '48px';
export const SPACE_M = '16px';
export const SPACE_L = '24px';

export const SLIDE_IMAGE_MAX_HEIGHT = '65px';
export const SLIDE_IMAGE_MAX_WIDTH = '210px';
export const SLIDE_TITLE_WIDTH = '230px';
export const SLIDE_HEIGHT = '168px';
